"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateOrganizationUserDtoSchema = exports.OrganizationUserDtoSchema = void 0;
const zod_1 = require("zod");
const user_1 = require("./user");
// Schema-first: the type is `z.infer`-derived below, not a hand-written interface
// checked against the schema. An explicit `z.ZodType<OrganizationUserDto>` annotation
// here type-checks under TS 4.9 (this package's own build) but fails under TS 5.9
// (which apps/routing-functions' test runner resolves for this same source file via
// its jest moduleNameMapper) — verified empirically. Schema-first avoids the mismatch
// and keeps a single source of truth.
exports.OrganizationUserDtoSchema = zod_1.z.object({
    id: zod_1.z.string(),
    firstname: zod_1.z.string(),
    lastname: zod_1.z.string(),
    email: zod_1.z.string().nullable(),
    mobileNumber: zod_1.z.string().nullable(),
    role: zod_1.z.nativeEnum(user_1.UserRole),
    isActive: zod_1.z.boolean(),
    status: zod_1.z.nativeEnum(user_1.UserStatus),
    lastLoginAt: zod_1.z.string().nullable(),
    maxBookingsPerMonth: zod_1.z.number(),
    usedBookingsThisMonth: zod_1.z.number().int().nonnegative(),
    createdAt: zod_1.z.string(),
});
/** Editable subset of `OrganizationUserDto` — server-computed fields are omitted. */
exports.UpdateOrganizationUserDtoSchema = exports.OrganizationUserDtoSchema.omit({
    id: true,
    status: true,
    lastLoginAt: true,
    usedBookingsThisMonth: true,
    createdAt: true,
}).partial();
//# sourceMappingURL=organization.js.map